import {
  GET_PROVIDER_PURCHASING_MECHANISMS,
  GET_PROVIDER_PURCHASING_MECHANISMS_ERROR,
  GET_PROVIDER_PURCHASING_MECHANISMS_SUCCESS
} from './ProviderPurchasingMechanismsSection.actions'

const providerPurchasingMechanismsSectionState = {
  categories: [],
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The provider purchasing mechanisms section's reducer.
 */
const providerPurchasingMechanismsSectionReducer = (
  state = providerPurchasingMechanismsSectionState,
  { payload, type }
) => {
  switch (type) {
    case GET_PROVIDER_PURCHASING_MECHANISMS: {
      return { ...state, loading: true }
    }
    case GET_PROVIDER_PURCHASING_MECHANISMS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDER_PURCHASING_MECHANISMS_SUCCESS: {
      return { ...state, categories: payload.categories, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default providerPurchasingMechanismsSectionReducer
